module.exports = __webpack_public_path__ + "img/icon_city6.45e913f8.png";